import React, { PropsWithChildren } from "react";
import { MDSSidebarSectionSlotName } from "@/mds/components/sidebar/sidebar.types";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";
import styled from "@emotion/styled";

interface MDSSidebarSectionProps extends PropsWithChildren {
  isExpanded: boolean;
}

export const MDSSidebarSection = ({ children, isExpanded }: MDSSidebarSectionProps) => {
  const unslottedChildren = getUnslottedChildren(children);
  const header = getSlot(children, MDSSidebarSectionSlotName.Header);

  return (
    <StyledContainer>
      {header}
      {isExpanded && <StyledContentContainer>{unslottedChildren}</StyledContentContainer>}
    </StyledContainer>
  );
};

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["0.5"]};
`;

export const StyledContentContainer = styled.div``;
